import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { SPTInstructionStatic } from "./STPInstructionStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const SPTInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const SPTInstructionStore: SPTInstructionStatic = new SPTInstructionStatic();

